"use client";

import { sessionsCountSchema } from "../../../../lib/types/schema/home/sessionCountSchema";
import type { UseRequestQueryProps } from "../../../../request/hooks/useRequestQuery";
import { useRequestQuery } from "../../../../request/hooks/useRequestQuery";
import { keySessionsCount } from "./keySessionsCount";

export type UseRequestSessionsCountProps = UseRequestQueryProps;

export const useRequestSessionsCount = ({
  ...props
}: UseRequestSessionsCountProps = {}) => ({
  query: useRequestQuery({
    ...props,
    queryFnRequestProps: {
      schema: sessionsCountSchema,
      urlBackendPath: "/sessions/count",
    },
    queryKey: keySessionsCount(),
  }),
});
